import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
}

/**
 * An empty radar web — the thing that is missing when a framework places none of its controls in
 * a hierarchy. Named after what is absent rather than borrowing a generic chart glyph, so the
 * empty state reads as "there is no spider here yet" at a glance.
 */
export const SpiderEmptySvg: React.FC<Props> = ({ size = 64 }) => {
  const colors = useTheme().colors;
  const outer = '32,6 56.7,24 47.3,53 16.7,53 7.3,24';
  const inner = '32,19 44.4,28 39.6,42.5 24.4,42.5 19.6,28';

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g stroke={colors.cflowerBlue} strokeLinejoin="round" strokeLinecap="round">
        <polygon points={outer} strokeWidth="2" opacity="0.9" />
        <polygon points={inner} strokeWidth="1.5" opacity="0.45" />
        <g strokeWidth="1.5" opacity="0.35">
          <line x1="32" y1="32" x2="32" y2="6" />
          <line x1="32" y1="32" x2="56.7" y2="24" />
          <line x1="32" y1="32" x2="47.3" y2="53" />
          <line x1="32" y1="32" x2="16.7" y2="53" />
          <line x1="32" y1="32" x2="7.3" y2="24" />
        </g>
      </g>
    </svg>
  );
};
